<template>
  <div class="headCon">
    <div class="auto">
      <el-row class="fonttitle">
        <el-col :span="elspan" :offset="ofset" class="font1" ref="font1">
          <span class>
            <img src="../assets/image/head_font1.png" />
          </span>
        </el-col>
        <el-col :span="4" :offset="3" class="font2" ref="font2">
          <span>
            <img src="../assets/image/head_font2.png?1" />
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      elspan: 11,
      ofset: 5
    };
  },
  mounted() {
    // ani-slide
    setTimeout(() => {
      this.$refs.font1.$el.classList.add("ani-slide");
    }, 1000);
    setTimeout(() => {
      this.$refs.font2.$el.classList.add("ani-slide");
    }, 1500);
  }
};
</script>
<style scoped>
.headCon {
  float: left;
  width: 100%;
  min-width: 1300px;
  height: 820px;
  background: url(../assets/image/head_img.jpg?4) no-repeat center;
}
.auto {
  position: relative;
  width: 1300px;
  height: 100%;
  margin: 0 auto;
}

.fonttitle {
  padding-top: 95px;
  width: 100%;
}
/* .font1.ani-slide img,
.font2.ani-slide img {
  transform: translate(0);
  opacity: 1;
} */
.font1 img {
  width: 100%;
  max-width: 900px;
  /* transform: translateY(-200px);
  -moz-transform: translateY(-200px);
  -webkit-transform: translateY(-200px);
  -o-transform: translateY(-200px);
  opacity: 0;
  transition: all 0.6s;
  -moz-transition: all 0.6s;
  -webkit-transition: all 0.6s;
  -o-transition: all 0.6s; */
}

.font2 img {
  width: 100%;
  max-width: 290px;
  /* transform: translateY(-100px);
  -moz-transform: translateY(-100px);
  -webkit-transform: translateY(-100px);
  -o-transform: translateY(-100px);
  opacity: 0;
  transition: all 0.6s;
  -moz-transition: all 0.6s;
  -webkit-transition: all 0.6s;
  -o-transition: all 0.6s; */
}
</style>